export default __webpack_public_path__ + "static/media/party_blob.00da2bd4.gif";